import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65fc6e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"5vh"} }, null, -1))

import sm from "../data/sm.json";
import SocialMediaButton from "@/components/SocialMediaButton.vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "ContactView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [
        _createTextVNode("Contact")
      ])), [
        [_directive_motion_slide_visible_once_left]
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sm).accounts, (account) => {
      return (_openBlock(), _createElementBlock("div", {
        style: {"margin-top":"2vw"},
        key: account
      }, [
        _createVNode(SocialMediaButton, {
          title: account.title,
          color: account.color,
          icon: account.icon,
          link: account.link,
          textColor: account.textColor
        }, null, 8, ["title", "color", "icon", "link", "textColor"])
      ]))
    }), 128)),
    _hoisted_3
  ]))
}
}

})